export default __webpack_public_path__ + "static/media/IMG_8911 copie.5102f315.jpg";